export const resumeData = {
  
  "name": "Natalie Nguyen",
  "role": "Software Engineer specializing in C#, .NET Core/ASP.NET, Angular, TypeScript, and SQL Server architecture. Passionate about building scalable full-stack web applications, optimizing database performance, and automating Azure DevOps workflows.",
  "linkedin": "https://www.linkedin.com/in/uyenmai/",
  "github": "https://github.com/uyenntm",
  "website": "https://uyen.dev/",
  "school": "San Francisco Bay University",
  "degree1": {
    "name": "Master of Science in Computer Science",
    "graduate_time": "Fremont, CA",
    "contents": {
      "content_1": "GPA 4.0 / 4.0",
      "content_2": "Programming Instructor / Teaching Assistant"
    }
  },
  "jobs": [
    {
      "company": "Fitness International",
      "location": "Irvine, CA",
      "position": "Software Engineer",
      "duration": "May 2023 – Present",
      "description": [
        "Design, build, and maintain web applications using **C#, ASP.NET, Angular/TypeScript, and SQL Server** to support core business operations and high-traffic member services.",
        "Integrate application backends and workflows with **SharePoint Lists via REST APIs** to dynamically fetch, update, and synchronize operational data.",
        "Architect and maintain complex stored procedures, user-defined functions, and dynamic T-SQL scripts to perform high-throughput data operations and reporting across large enterprise datasets.",
        "Lead **SQL Server query optimization** efforts by redesigning indexes and refactoring slow queries to significantly reduce execution times.",
        "Build and manage **Azure DevOps CI/CD pipelines** to automate build and deployment workflows, accelerating release cycles and reducing manual deployment errors.",
        "Develop **RESTful APIs** and backend microservices, optimizing data transfer and system integrations across external and internal systems.",
        "Collaborate closely with product managers and cross-functional teams to translate business requirements into clean, maintainable technical solutions."
      ]
    },
    {
      "company": "Decision Ready Solutions",
      "location": "Irvine, CA",
      "position": "Software Engineer",
      "duration": "March 2020 – February 2023",
      "description": [
        "Engineered full-stack web solutions using **ASP.NET MVC, Entity Framework, JavaScript, Bootstrap, and jQuery** for major financial clients, including Fannie Mae, PennyMac, and Fifth Third Bank.",
        "Architected robust backend integration pipelines using **REST APIs** to securely retrieve, validate, and process complex loan data in compliance with strict financial standards.",
        "Led database development efforts; designed normalized SQL Server schemas, authored complex T-SQL stored procedures, and built SSIS packages for automated data ingestion and financial reporting.",
        "Monitored and supported production environments, diagnosing complex database performance bottlenecks."
      ]
    },
    {
      "company": "San Francisco Bay University",
      "location": "Fremont, CA",
      "position": "Programming Instructor",
      "duration": "May 2016 – May 2017",
      "description": [
        "Instructed graduate and undergraduate students in JavaScript, C++, C, SQL, and Data Structures & Algorithms.",
        "Conducted lab assignments to provide hands-on experience with programming languages and data structures.",
        "Assessed student performance through quizzes, exams, and projects, providing constructive feedback to support their growth."
      ]
    },
    {
      "company": "Positive Thinking Company APAC",
      "location": "Hochiminh, Vietnam",
      "position": "Software Engineer",
      "duration": "March 2011 – October 2013",
      "description": [
        "Built and deployed Ligaris Intranet, an enterprise blogging and internal collaboration platform utilizing JavaScript, CSS, and MySQL.",
        "Developed Harlem Wine, a location-aware web tool leveraging JavaScript, jQuery, and MySQL to connect users with nearby wine retailers via location tracking APIs."
      ]
    },
    {
      "company": "Dirox",
      "location": "Hochiminh, Vietnam",
      "position": "Software Engineer",
      "duration": "January 2010 – February 2011",
      "description": [
        "Designed and built a centralized Project Management and Timesheet Application using jQuery, JavaScript, and MySQL to streamline internal employee hours tracking and operational reporting."
      ]
    }
  ],
  "skills": {
    "languages_frameworks": "**Languages & Frameworks**: C#, .NET Core, Web API, ASP.NET MVC, TypeScript, Angular, Entity Framework, JavaScript, RESTful APIs",
    "databases_data": "**Databases & Data Engineering**: Microsoft SQL Server, T-SQL, Stored Procedures, Query Optimization, Indexing Strategies, Views",
    "devops_cloud": "**DevOps & Cloud**: Azure DevOps, Azure Pipelines (CI/CD), Git/GitHub, TFS",
   
  }
};
export default resumeData;